import { apiRequest } from "./client";
import type {
  ApiAgeGroup,
  ApiCategory,
  ApiLeadCapturePayload,
  ApiLeadCaptureResponse,
  ApiProduct,
  ApiReport,
  ApiSkill,
  ApiParentRegisterPayload,
  ApiParentLoginPayload,
  ApiChildPayload,
  ApiParentProfile,
  ApiCheckoutRequest,
  ApiUpdateProfilePayload,
  ApiUpdateChildPayload,
  ApiForgotPasswordPayload,
  ApiResetPasswordPayload,
} from "./types";

export const fetchAgeGroups = (lang: string) => {
  return apiRequest<ApiAgeGroup[]>("/age-groups", { params: { lang } });
};

export const fetchCategories = (lang: string) => {
  return apiRequest<ApiCategory[]>("/categories", { params: { lang } });
};

export const fetchSkills = (ageGroupId: number, lang: string) => {
  return apiRequest<ApiSkill[]>("/skills", { params: { ageGroupId, lang } });
};

export const fetchProducts = (ageGroupId: number, lang: string, categoryId?: number) => {
  return apiRequest<ApiProduct[]>("/products", { params: { ageGroupId, categoryId, lang } });
};

export const createLeadCapture = (payload: ApiLeadCapturePayload) => {
  return apiRequest<ApiLeadCaptureResponse>("/lead-capture", { method: "POST", body: payload });
};

export const fetchReport = (reportId: string) => {
  return apiRequest<ApiReport>(`/reports/${reportId}`);
};

export const parentRegister = (payload: ApiParentRegisterPayload) => {
  return apiRequest<{ token: string; parent: any }>("/parents/register", { method: "POST", body: payload });
};

export const parentLogin = (payload: ApiParentLoginPayload) => {
  return apiRequest<{ token: string; parent: any }>("/parents/login", { method: "POST", body: payload });
};

export const fetchParentProfile = () => {
  return apiRequest<ApiParentProfile>("/parents/me");
};

export const fetchParentCheckoutRequests = () => {
  return apiRequest<ApiCheckoutRequest[]>("/parents/checkout-requests");
};

export const parentAddChild = (payload: ApiChildPayload) => {
  return apiRequest<any>("/parents/child", { method: "POST", body: payload });
};

export const updateParentProfile = (payload: ApiUpdateProfilePayload) => {
  return apiRequest<{ id: string; name: string; email: string; phoneNumber: string }>(
    "/parents/profile",
    { method: "PUT", body: payload }
  );
};

export const updateChild = (childId: string, payload: ApiUpdateChildPayload) => {
  return apiRequest<any>(`/parents/child/${childId}`, { method: "PUT", body: payload });
};

export const forgotPassword = (payload: ApiForgotPasswordPayload) => {
  return apiRequest<{ ok: boolean }>("/parents/forgot-password", { method: "POST", body: payload });
};

export const resetPasswordApi = (payload: ApiResetPasswordPayload) => {
  return apiRequest<{ ok: boolean }>("/parents/reset-password", { method: "POST", body: payload });
};

export const emailReport = (reportId: string, lang: string) => {
  return apiRequest<{ ok: boolean }>(`/reports/${reportId}/email`, { method: "POST", params: { lang } });
};

export {
  createCheckoutSession,
  prepareProductsForCheckout,
  redirectToCheckout,
} from "./checkout";

export type {
  CreateCheckoutSessionRequest,
  CreateCheckoutSessionResponse,
} from "./checkout";
